// External deps
import { useContext } from 'react';

// Internal deps
import { UserTrazabilityContext } from '../context/UserTrazabilityContext';

export default function useUserTrazability() {
  return useContext(UserTrazabilityContext);
}
